<template>
  <div v-if="productPrice" class="pricing">
    <span class="price-reg"> {{ productPrice }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  pricing: {
    type: Object,
    default: () => ({}),
  },
});

const productPrice = computed(() => {
  const tieredPrice = props.pricing?.tieredPrice;
  if (!tieredPrice?.length) return null;

  const label = tieredPrice[0]?.label;
  if (label?.startsWith('[PRICE]')) {
    return tieredPrice[0]?.values?.[0]?.formattedValue ?? null;
  }
  return null;
});
</script>
<style lang="scss" scoped>
.pricing .price-reg {
  font-weight: $font-weight-heavy;
}
</style>
